"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TabContent = ({
  className,
  children,
  selectedIndex,
  renderActiveOnly
}) => {
  const classes = (0, _classnames.default)('TabContent', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, _react.Children.map(children, (panel, i) => {
    if (panel) {
      if (renderActiveOnly) {
        if (selectedIndex === i) {
          return /*#__PURE__*/(0, _react.cloneElement)(panel, {
            active: true,
            index: i
          });
        } else {
          return null;
        }
      } else {
        return /*#__PURE__*/(0, _react.cloneElement)(panel, {
          active: selectedIndex === i,
          index: i
        });
      }
    }
  }));
};
var _default = exports.default = TabContent;